class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

open() {
  this.activeElement = document.activeElement;

  this.notification.classList.add('animate', 'active');

  // Capture la position du scroll actuel
  const scrollY = window.scrollY || document.documentElement.scrollTop;

  // Positionne le popup au niveau du scroll actuel
  this.notification.style.position = 'absolute'; // ou 'fixed' si tu veux qu'il reste fixe pendant le scroll
  this.notification.style.top = `${scrollY + 20}px`; // Ajouter un petit espace au-dessus (20px)

  const afterOpen = () => {
    // Met le focus sur la notification sans provoquer de scroll
    this.notification.focus({ preventScroll: true });
    trapFocus(this.notification);
  };

  // Écoute l'événement de fin de transition
  this.notification.addEventListener('transitionend', afterOpen, { once: true });

  // Si transitionend ne se déclenche pas, utiliser un fallback pour appliquer le focus immédiatement
  requestAnimationFrame(afterOpen);

  // Ajouter l'écouteur de clic sur le corps pour fermer la popup si on clique en dehors
  document.body.addEventListener('click', this.onBodyClick);

  // Timer pour fermer la popup après 1 seconde
  setTimeout(() => {
    this.close(); // Appelle la méthode close() pour cacher la notification
  }, 2500); // 1000ms = 1 seconde
}


  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
